/**
 * Funcionalidades terminadas pero ocultas hasta que se decida habilitarlas.
 */

//* Botón "Permiso Día" (permiso de día completo) en el kiosk. Funciona contra
//* `station/v2/request/others/{workerId}/complete`; con `false` no se renderiza
//* ni cuenta para mostrar la barra de acciones.
export const KIOSK_FULL_DAY_PERMISSION_ENABLED = false;
